import {safelyGetStorageItem} from '@vio/core/src/_web/utils/persistence/safelyGetStorageItem'
import {safelySetStorageItem} from '@vio/core/src/_web/utils/persistence/safelySetStorageItem'

const SESSION_STORAGE_KEY = 'chat_sessionId'

export const getPersistedSessionId = (): string | null =>
  safelyGetStorageItem(sessionStorage, SESSION_STORAGE_KEY) ?? null

export function persistSessionId(sessionId: string | null) {
  if (sessionId) {
    safelySetStorageItem(sessionStorage, SESSION_STORAGE_KEY, sessionId)
  } else if (typeof window !== 'undefined') {
    try {
      sessionStorage.removeItem(SESSION_STORAGE_KEY)
    } catch {
      // Ignore storage errors
    }
  }
}
